import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { AdminGuard } from '@/features/admin/components/admin-guard';
import { AdminLayout } from '@/layouts/admin-layout';
import { isAdmin } from '@/lib/permissions';
import { requireAuthenticated } from '@/lib/route-guards';

/**
 * Admin route group.
 *
 * Sits at the top level rather than under `_authenticated` so it renders
 * AdminLayout instead of AppLayout — nesting the two would stack their headers.
 * It repeats the signed-in checks through requireAuthenticated so nothing is
 * lost by not inheriting them.
 */
export const Route = createFileRoute('/admin')({
  beforeLoad: ({ location }) => {
    const user = requireAuthenticated(location.href);

    // Only reject a caller already known to lack access. A null user means the
    // profile has not resolved yet, and AdminGuard picks that case up once it
    // does.
    if (user && !isAdmin(user)) {
      throw redirect({ to: '/' });
    }
  },
  component: AdminRoute,
});

function AdminRoute() {
  return (
    <AdminGuard>
      <AdminLayout>
        <Outlet />
      </AdminLayout>
    </AdminGuard>
  );
}
